import DialogContent, {
  dialogContentClasses,
  DialogContentProps,
} from '@mui/material/DialogContent';
import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import IconButton, {
  iconButtonClasses,
  IconButtonProps,
} from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography, {
  typographyClasses,
  TypographyProps,
} from '@mui/material/Typography';

import LinkButton, { ILinkButtonProps } from '~/components/LinkButton';

export const StyledDialogContent = styled(DialogContent)<DialogContentProps>(
  ({ theme }) => ({
    [`&.${dialogContentClasses.root}`]: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(4),
      position: 'relative',
    },
  }),
);

export const StyledIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    [`&.${iconButtonClasses.root}`]: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  }),
);

export const StyledTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(1),
    },
  }),
);

export const StyledGridContainer = styled(Grid)<GridProps>({
  [`&.${gridClasses.container}`]: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    width: 'auto',
  },
});
export const StyledSignOutButton = styled(LinkButton)<ILinkButtonProps>(
  ({ theme }) => ({
    color: theme.palette.error.dark,
  }),
);
